import React from "react";
import PropTypes from "prop-types";
import KVTable from "./KVTable.react.js";

/**
 * API 请求体表单（none / form-data / x-www-form-urlencoded / raw 四种）
 */
function BodyForm({
  bodyType,
  rawFormat,
  rawBody,
  formData,
  urlEncoded,
  isEdit = true,
  onMetaChange,
  onFormDataChange,
  onFormDataAdd,
  onFormDataDelete,
  onUrlEncodedChange,
  onUrlEncodedAdd,
  onUrlEncodedDelete,
}) {
  return (
    <div>
      <div className="tfe-pm-radio-group">
        {["none", "form-data", "x-www-form-urlencoded"].map((t) => (
          <label key={t} className="tfe-pm-radio-label">
            <input
              type="radio"
              checked={bodyType === t}
              disabled={!isEdit}
              onChange={() => onMetaChange("bodyType", t)}
            />
            {" "}{t}
          </label>
        ))}
        <label className="tfe-pm-radio-label">
          <input
            type="radio"
            checked={bodyType === "raw"}
            disabled={!isEdit}
            onChange={() => onMetaChange("bodyType", "raw")}
          />
          {" "}raw
          {bodyType === "raw" && (
            <select
              style={{
                border: "none",
                outline: "none",
                color: "var(--brand-primary)",
                fontWeight: "bold",
                background: "transparent",
              }}
              value={rawFormat}
              disabled={!isEdit}
              onChange={(e) => onMetaChange("rawFormat", e.target.value)}
            >
              <option value="JSON">JSON</option>
              <option value="Text">Text</option>
              <option value="XML">XML</option>
            </select>
          )}
        </label>
      </div>
      {bodyType === "none" && (
        <div className="tfe-empty-placeholder">此请求没有 Body 体。</div>
      )}
      {bodyType === "form-data" && (
        <KVTable
          rows={formData}
          type="kv"
          isEdit={isEdit}
          onChange={onFormDataChange}
          onAdd={onFormDataAdd}
          onDelete={onFormDataDelete}
        />
      )}
      {bodyType === "x-www-form-urlencoded" && (
        <KVTable
          rows={urlEncoded}
          type="kv_pair"
          isEdit={isEdit}
          onChange={onUrlEncodedChange}
          onAdd={onUrlEncodedAdd}
          onDelete={onUrlEncodedDelete}
        />
      )}
      {bodyType === "raw" && (
        <textarea
          className="tfe-raw-editor"
          value={rawBody ?? ""}
          readOnly={!isEdit}
          onChange={(e) => onMetaChange("rawBody", e.target.value)}
          placeholder="在此输入 raw body 内容..."
          spellCheck={false}
        />
      )}
    </div>
  );
}

BodyForm.propTypes = {
  bodyType: PropTypes.oneOf(["none", "form-data", "x-www-form-urlencoded", "raw"]),
  rawFormat: PropTypes.oneOf(["JSON", "Text", "XML"]),
  rawBody: PropTypes.string,
  formData: PropTypes.array,
  urlEncoded: PropTypes.array,
  /** 是否允许编辑（true=可切换 body 类型、raw 格式与编辑内容；false=只读查看，控件禁用）。默认 true。 */
  isEdit: PropTypes.bool,
  onMetaChange: PropTypes.func.isRequired,
  onFormDataChange: PropTypes.func.isRequired,
  onFormDataAdd: PropTypes.func.isRequired,
  onFormDataDelete: PropTypes.func.isRequired,
  onUrlEncodedChange: PropTypes.func.isRequired,
  onUrlEncodedAdd: PropTypes.func.isRequired,
  onUrlEncodedDelete: PropTypes.func.isRequired,
};

export default BodyForm;
